<template>
<div v-if="order" class="detail-page">
  <div class="detail-toolbar">
    <el-button icon="el-icon-arrow-left" size="small" @click="$emit('back')">{{ $t('返回订单列表') }}</el-button>
    <strong>{{ $t('订单详情') }}</strong>
    <span>{{ order.referenceNo }}</span>
    <div class="detail-actions">
      <el-button size="small" icon="el-icon-location-outline" @click="$emit('trace')">{{ $t('运单轨迹') }}</el-button>
      <el-button v-if="order.status === 'SUCCESS'" size="small" icon="el-icon-view" @click="$emit('preview')">{{ $t('查看面单') }}</el-button>
      <el-button v-if="order.status === 'SUCCESS'" size="small" icon="el-icon-download" @click="$emit('download')">{{ $t('下载面单') }}</el-button>
    </div>
  </div>

  <section class="detail-section">
    <h2>{{ $t('基本信息') }}</h2>
    <div class="detail-fields">
      <div v-for="item in basicFields" :key="item.label" class="detail-field"><span>{{ $t(item.label) }}</span><strong>{{ item.value }}</strong></div>
    </div>
  </section>

  <section class="detail-section">
    <div class="detail-section-title"><h2>{{ $t('包裹信息') }}</h2><el-button type="text" icon="el-icon-refresh" :loading="piecesLoading" @click="$emit('refresh-pieces')">{{ $t('刷新包裹') }}</el-button></div>
    <el-table :data="visiblePieces" border stripe :empty-text="$t('暂无包裹明细')" class="detail-table">
      <el-table-column type="index" label="#" width="55" align="center" />
      <el-table-column :label="$t('子单号码')" min-width="145"><template slot-scope="scope">{{ value(scope.row.childJobno || scope.row.childRefno) }}</template></el-table-column>
      <el-table-column :label="$t('件数')" width="75" align="right"><template slot-scope="scope">{{ value(scope.row.pcs) }}</template></el-table-column>
      <el-table-column :label="$t(`重量(${displayWeightUnit})`)" width="105" align="right"><template slot-scope="scope">{{ value(scope.row.actual) }}</template></el-table-column>
      <el-table-column :label="$t(`长(${displayDimensionUnit})`)" width="95" align="right"><template slot-scope="scope">{{ value(scope.row.length) }}</template></el-table-column>
      <el-table-column :label="$t(`宽(${displayDimensionUnit})`)" width="95" align="right"><template slot-scope="scope">{{ value(scope.row.width) }}</template></el-table-column>
      <el-table-column :label="$t(`高(${displayDimensionUnit})`)" width="95" align="right"><template slot-scope="scope">{{ value(scope.row.height) }}</template></el-table-column>
      <el-table-column :label="$t('出账状态')" width="105"><template slot-scope="scope">{{ value(scope.row.billingStatus) }}</template></el-table-column>
      <el-table-column :label="$t('参考编号')" min-width="150"><template slot-scope="scope">{{ value(scope.row.referenceno) }}</template></el-table-column>
      <el-table-column :label="$t('参考编号2')" min-width="140"><template slot-scope="scope">{{ value(scope.row.referenceno2) }}</template></el-table-column>
      <el-table-column :label="$t('保险价值')" min-width="125"><template slot-scope="scope">{{ scope.row.insuranceValue == null ? '-' : `${scope.row.insuranceValue} ${scope.row.insuranceValueCur || ''}` }}</template></el-table-column>
    </el-table>
    <p v-if="piecesError" class="detail-note">{{ $t('平台实时详情暂未读取成功，当前显示下单时保存的信息。可点击刷新重试。') }}</p>
  </section>

  <section class="detail-section">
    <h2>{{ $t('Invoice 信息') }} <small>{{ value(payload.decValueCur) }}</small></h2>
    <el-table :data="invoices" border stripe :empty-text="$t('暂无 Invoice 信息')" class="detail-table">
      <el-table-column type="index" label="#" width="55" align="center" />
      <el-table-column :label="$t('商品名称')" min-width="180"><template slot-scope="scope">{{ value(scope.row.eDescrNamee || scope.row.eDecsName) }}</template></el-table-column>
      <el-table-column :label="$t('数量')" width="80"><template slot-scope="scope">{{ value(scope.row.qty) }}</template></el-table-column>
      <el-table-column :label="$t('单价')" width="100"><template slot-scope="scope">{{ value(scope.row.price) }}</template></el-table-column>
      <el-table-column :label="$t('总价')" width="100"><template slot-scope="scope">{{ invoiceTotal(scope.row) }}</template></el-table-column>
      <el-table-column :label="$t('海关编码')" min-width="120"><template slot-scope="scope">{{ value(scope.row.hsCode) }}</template></el-table-column>
      <el-table-column :label="$t('原产地')" min-width="100"><template slot-scope="scope">{{ value(scope.row.originCountryCode) }}</template></el-table-column>
      <el-table-column label="SKU" min-width="110"><template slot-scope="scope">{{ value(scope.row.sku) }}</template></el-table-column>
      <el-table-column :label="$t('净重')" width="90"><template slot-scope="scope">{{ value(scope.row.nWeig) }}</template></el-table-column>
    </el-table>
  </section>

  <section class="detail-section contact-section">
    <h2>{{ $t('收件信息') }}</h2>
    <div class="contact-table-wrap">
      <table class="contact-table">
        <colgroup><col v-for="column in 10" :key="column"></colgroup>
        <thead>
          <tr><th rowspan="2">{{ $t('联系人') }}</th><th rowspan="2">{{ $t('公司') }}</th><th rowspan="2">{{ $t('电话') }}</th><th colspan="7">{{ $t('地址信息') }}</th></tr>
          <tr><th>{{ $t('国家') }}</th><th>{{ $t('州省') }}</th><th>{{ $t('城市') }}</th><th>{{ $t('邮编') }}</th><th>{{ $t('邮箱') }}</th><th>{{ $t('地址') }}</th><th>{{ $t('地址2') }}</th></tr>
        </thead>
        <tbody><tr><td>{{ contactValue(receiver, 're', 'Name') }}</td><td>{{ contactValue(receiver, 're', 'Company') }}</td><td>{{ contactValue(receiver, 're', 'Tel') }}</td><td>{{ contactValue(receiver, 're', 'CountryCode') }}</td><td>{{ contactValue(receiver, 're', 'State') }}</td><td>{{ contactValue(receiver, 're', 'City') }}</td><td>{{ contactValue(receiver, 're', 'Zip') }}</td><td>{{ contactValue(receiver, 're', 'Email') }}</td><td>{{ contactValue(receiver, 're', 'Addr') }}</td><td>{{ contactValue(receiver, 're', 'Addr2') }}</td></tr></tbody>
      </table>
    </div>
  </section>
  <section class="detail-section contact-section">
    <h2>{{ $t('寄件信息') }}</h2>
    <div class="contact-table-wrap">
      <table class="contact-table">
        <colgroup><col v-for="column in 10" :key="column"></colgroup>
        <thead>
          <tr><th rowspan="2">{{ $t('联系人') }}</th><th rowspan="2">{{ $t('公司') }}</th><th rowspan="2">{{ $t('电话') }}</th><th colspan="7">{{ $t('地址信息') }}</th></tr>
          <tr><th>{{ $t('国家') }}</th><th>{{ $t('州省') }}</th><th>{{ $t('城市') }}</th><th>{{ $t('邮编') }}</th><th>{{ $t('邮箱') }}</th><th>{{ $t('地址') }}</th><th>{{ $t('地址2') }}</th></tr>
        </thead>
        <tbody><tr><td>{{ contactValue(sender, 'sd', 'Name') }}</td><td>{{ contactValue(sender, 'sd', 'Company') }}</td><td>{{ contactValue(sender, 'sd', 'Tel') }}</td><td>{{ contactValue(sender, 'sd', 'CountryCode') }}</td><td>{{ contactValue(sender, 'sd', 'State') }}</td><td>{{ contactValue(sender, 'sd', 'City') }}</td><td>{{ contactValue(sender, 'sd', 'Zip') }}</td><td>{{ contactValue(sender, 'sd', 'Email') }}</td><td>{{ contactValue(sender, 'sd', 'Addr') }}</td><td>{{ contactValue(sender, 'sd', 'Addr2') }}</td></tr></tbody>
      </table>
    </div>
  </section>
  <section class="detail-section">
    <h2>{{ $t('订单记录') }}</h2>
    <el-timeline class="detail-timeline">
      <el-timeline-item :timestamp="value(order.createdAt)">{{ $t('订单已创建') }}</el-timeline-item>
      <el-timeline-item v-if="order.platformSyncedAt" :timestamp="order.platformSyncedAt">{{ $t('已同步平台订单状态') }}</el-timeline-item>
      <el-timeline-item v-if="order.billingImportedAt" :timestamp="order.billingImportedAt">{{ $t('已导入平台账单') }}</el-timeline-item>
    </el-timeline>
    <p v-if="order.failureReason" class="detail-note">{{ $t(`处理提示：${order.failureReason}`) }}</p>
  </section>
  <section class="detail-section">
    <h2>{{ $t('关联资金流水') }}</h2>
    <el-table :data="order.ledgerEntries || []" border stripe :empty-text="$t('暂无关联资金流水')" class="detail-table">
      <el-table-column prop="createdAt" :label="$t('发生时间')" min-width="160" />
      <el-table-column :label="$t('类型')" min-width="140"><template slot-scope="scope">{{ ledgerTypeText(scope.row.bizType) }}</template></el-table-column>
      <el-table-column :label="$t('发生金额')" min-width="125" align="right"><template slot-scope="scope"><span :class="ledgerChangeValue(scope.row) >= 0 ? 'credit-change' : 'debit-change'">{{ ledgerChange(scope.row) }} {{ order.currency || 'USD' }}</span></template></el-table-column>
      <el-table-column :label="$t('所属账户')" min-width="100"><template slot-scope="scope">{{ scope.row.bizType && scope.row.bizType.startsWith('DEPOSIT_') ? $t('押金') : $t('可用余额') }}</template></el-table-column>
      <el-table-column :label="$t('说明')" min-width="210" show-overflow-tooltip><template slot-scope="scope">{{ ledgerRemark(scope.row) }}</template></el-table-column>
      <el-table-column v-if="isAdmin" prop="operatorName" :label="$t('操作人')" min-width="110" />
    </el-table>
  </section>
</div>
</template>

<script>
import { ledgerRemark } from '../../i18n/ledger'
import { translateUi } from '../../i18n'
export default {
  name: 'TransportOrderDetail',
  props: {
    order: { type: Object, default: null },
    isAdmin: { type: Boolean, default: false },
    pieces: { type: Array, default: () => [] },
    piecesLoading: { type: Boolean, default: false },
    piecesError: { type: Boolean, default: false }
  },
  computed: {
    payload () { return this.parse(this.order && this.order.payloadJson) },
    receiver () { return this.party(this.parse(this.order && this.order.receiverJson), this.payload, 're', 'recipient') },
    sender () { return this.party(this.parse(this.order && this.order.senderJson), this.payload, 'sd', 'sender') },
    invoices () { return Array.isArray(this.payload.oisInvoices) ? this.payload.oisInvoices : [] },
    displayWeightUnit () { return String((this.order && this.order.displayWeightUnit) || this.payload.displayWeightUnit || 'KG').toUpperCase() === 'LBS' ? 'LBS' : 'KG' },
    displayDimensionUnit () { return String((this.order && this.order.displayDimensionUnit) || this.payload.displayDimensionUnit || 'CM').toUpperCase() === 'IN' ? 'IN' : 'CM' },
    visiblePieces () {
      if (!this.pieces.length) return Array.isArray(this.payload.displayPieces) ? this.payload.displayPieces : (Array.isArray(this.payload.pieces) ? this.payload.pieces : [])
      return this.pieces.map(piece => this.convertPlatformPiece(piece))
    },
    basicFields () {
      const order = this.order || {}
      const signature = { 0: translateUi('否'), 1: translateUi('普通签名'), 2: translateUi('成人签名') }
      return [
        ['订单号码', order.referenceNo], ['运单号码', order.trackingNo || order.jobNo], ['产品', order.productName],
        ['订单件数', this.pieces.length || order.pieceCount],
        ['预扣费金额', order.status === 'SUCCESS' ? `${this.value(order.customerAmount)} ${order.currency || ''}` : '-'],
        [this.isAdmin ? '平台累计出账' : '客户累计扣费', order.billingStatus !== 'PENDING' && (this.isAdmin ? order.providerBilledAmount != null : order.customerBilledTotal != null) ? `${this.value(this.isAdmin ? order.providerBilledAmount : Math.abs(Number(order.customerBilledTotal || 0)))} ${order.currency || ''}` : '-'],
        ...(this.isAdmin ? [['客户累计扣费', order.billingStatus !== 'PENDING' && order.customerBilledTotal != null ? `${this.value(Math.abs(Number(order.customerBilledTotal || 0)))} ${order.currency || ''}` : '-']] : []),
        ['累计出账件数', order.billedPieceCount || 0],
        ['剩余未出账件数', Math.max(0, Number(order.forecastPieceCount || order.pieceCount || 0) - Number(order.billedPieceCount || 0))],
        ['账单状态', this.billingStatusText(order.billingStatus)], ['订单日期', order.createdAt], ['订单状态', this.statusText(order.status)],
        ['计费重量', order.chargeWeight == null ? null : `${order.chargeWeight} ${order.chargeWeightUnit || ''}`],
        ['偏远地区', order.isFaraway == null ? null : (order.isFaraway ? translateUi('是') : translateUi('否'))], ['偏远等级', order.farawayGrade],
        ['密度', this.payload.density], ['签名服务', signature[this.payload.isSignatureService] || this.payload.isSignatureService],
        ['分区 / 账单分区', null], ['备注', this.payload.remark],
        ...(order.deletedAt ? [
          ['删除退款状态', this.deleteRefundStatusText(order.deleteRefundStatus)],
          ['退款计划时间', order.deleteRefundDueAt],
          ['退款完成时间', order.deleteRefundedAt]
        ] : [])
      ].map(([label, raw]) => ({ label, value: this.value(raw) }))
    }
  },
  methods: {
    ledgerRemark,
    parse (raw) { try { return typeof raw === 'string' ? JSON.parse(raw) || {} : raw || {} } catch (error) { return {} } },
    party (stored, payload, prefix, nestedKey) {
      const result = {}
      const storedNested = stored && stored[nestedKey] && typeof stored[nestedKey] === 'object' ? stored[nestedKey] : {}
      const payloadNested = payload && payload[nestedKey] && typeof payload[nestedKey] === 'object' ? payload[nestedKey] : {}
      const nested = { ...payloadNested, ...storedNested }
      const aliases = {
        Name: ['name', 'Name'],
        Company: ['company', 'Company'],
        Tel: ['tel', 'phone', 'Tel'],
        CountryCode: ['countryCode', 'country', 'CountryCode'],
        State: ['state', 'State'],
        City: ['city', 'City'],
        Zip: ['zip', 'postalCode', 'Zip'],
        Email: ['email', 'Email'],
        Addr: ['addr', 'address', 'Addr'],
        Addr2: ['addr2', 'address2', 'Addr2'],
        Addr3: ['addr3', 'address3', 'Addr3']
      }
      Object.keys(aliases).forEach(suffix => {
        const key = prefix + suffix
        const value = stored && stored[key] != null && stored[key] !== ''
          ? stored[key]
          : (payload && payload[key] != null && payload[key] !== ''
            ? payload[key]
            : aliases[suffix].map(alias => nested[alias]).find(value => value != null && value !== ''))
        if (value != null && value !== '') result[key] = value
      })
      return result
    },
    value (raw) { return raw == null || raw === '' ? '-' : String(raw) },
    statusText (status) { return { PREPARING: translateUi('待确认'), SUBMITTING: translateUi('处理中'), SUCCESS: translateUi('预报成功'), API_FAILED: translateUi('预报失败'), REVIEW_REQUIRED: translateUi('待核对') }[status] || this.value(status) },
    billingStatusText (status) { return { PENDING: translateUi('费用冻结'), PARTIALLY_BILLED: translateUi('部分出账'), BILLED: translateUi('已全部出账'), INSUFFICIENT_DEPOSIT: translateUi('押金不足') }[status] || this.value(status) },
    deleteRefundStatusText (status) { return { NONE: translateUi('无需退款'), PENDING: translateUi('次日待退款'), COMPLETED: translateUi('已退款'), FAILED: translateUi('退款待重试') }[status] || this.value(status) },
    ledgerTypeText (type) { return { REFERRAL_REWARD: translateUi('推荐返利'), REFERRAL_REVERSAL: translateUi('返利冲回'), ORDER_DEBIT: translateUi('账单正式扣费'), ORDER_REFUND: translateUi('订单退回'), ORDER_DELETE_REFUND: translateUi('删除订单退款'), DEPOSIT_CREDIT: translateUi('收取押金'), DEPOSIT_CREDIT_REVERSAL: translateUi('押金充值撤回'), DEPOSIT_RETURN: translateUi('退还押金'), DEPOSIT_DEBIT: translateUi('扣取押金'), DEPOSIT_REPLENISH: translateUi('补足押金'), DEPOSIT_REPLENISH_REVERSAL: translateUi('撤回押金补足'), DEPOSIT_BILL_REFUND: translateUi('账单押金返还'), BILLING_BALANCE_REFUND: translateUi('账单余额返还'), DEPOSIT_DELETE_RETURN: translateUi('删除订单押金退回') }[type] || this.value(type) },
    ledgerChangeValue (row) {
      if (['ORDER_FREEZE', 'ORDER_UNFREEZE'].includes(row.bizType)) return -Number(row.frozenChange || 0)
      return Number(row.creditAmount || 0) - Number(row.debitAmount || 0)
    },
    ledgerChange (row) { const amount = this.ledgerChangeValue(row); return (amount > 0 ? '+' : '') + amount.toFixed(2) },
    invoiceTotal (item) { const total = Number(item.qty) * Number(item.price); return Number.isFinite(total) ? total.toFixed(2) : '-' },
    convertPlatformPiece (piece) {
      const result = { ...piece }
      if (this.displayWeightUnit === 'LBS' && result.actual != null) result.actual = this.convert(result.actual, 2.20462262185)
      if (this.displayDimensionUnit === 'IN') ['length', 'width', 'height'].forEach(field => { if (result[field] != null) result[field] = this.convert(result[field], 0.3937007874) })
      return result
    },
    convert (value, factor) {
      const number = Number(value)
      return Number.isFinite(number) ? Number((number * factor).toFixed(3)) : value
    },
    contactValue (party, prefix, suffix) {
      return this.value(party && party[prefix + suffix])
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-page { background: #f5f7f9; color: #263642; }
.detail-toolbar { display: flex; align-items: center; gap: 12px; min-height: 56px; padding: 8px 12px; background: #fff; border-bottom: 1px solid #dce3e8; }
.detail-toolbar strong { font-size: 16px; }
.detail-toolbar > span { color: #60717e; font-size: 13px; overflow-wrap: anywhere; }
.detail-actions { display: flex; flex-wrap: wrap; gap: 6px; margin-left: auto; }
.detail-actions .el-button + .el-button { margin-left: 0; }
.detail-section { margin-top: 10px; padding: 0 10px 10px; background: #fff; }
.detail-section h2 { margin: 0 -10px 10px; padding: 10px; background: #eef3f5; color: #15718b; font-size: 14px; font-weight: 700; }
.detail-section h2 small { margin-left: 8px; color: #64748b; font-size: 12px; font-weight: 400; }
.detail-section-title { display: flex; align-items: center; justify-content: space-between; background: #eef3f5; margin: 0 -10px 10px; padding-right: 10px; }
.detail-section-title h2 { margin: 0; }
.detail-fields { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 10px; }
.detail-field { min-width: 0; }
.detail-field span { display: block; margin-bottom: 5px; font-size: 12px; color: #485965; }
.detail-field strong { display: block; min-height: 30px; padding: 6px 8px; border: 1px solid #dce3e8; border-radius: 3px; color: #263642; background: #fafcfd; font-size: 12px; font-weight: 400; overflow-wrap: anywhere; }
.contact-table-wrap { width: 100%; overflow-x: auto; }
.contact-table { width: 100%; min-width: 1260px; border-collapse: collapse; table-layout: fixed; color: #263642; font-size: 12px; }
.contact-table col:nth-child(1) { width: 9%; }
.contact-table col:nth-child(2), .contact-table col:nth-child(3) { width: 11%; }
.contact-table col:nth-child(4) { width: 5%; }
.contact-table col:nth-child(5), .contact-table col:nth-child(7) { width: 6%; }
.contact-table col:nth-child(6) { width: 7%; }
.contact-table col:nth-child(8) { width: 8%; }
.contact-table col:nth-child(9) { width: 25%; }
.contact-table col:nth-child(10) { width: 12%; }
.contact-table th, .contact-table td { padding: 10px 12px; border: 1px solid #dce3e8; text-align: left; vertical-align: middle; }
.contact-table th { background: #edf3f5; color: #334657; font-weight: 600; white-space: nowrap; }
.contact-table thead tr:first-child th { background: #e4eef1; text-align: center; }
.contact-table td { min-height: 40px; background: #fff; overflow-wrap: break-word; word-break: normal; }
.detail-table { width: 100%; }
.detail-table ::v-deep .el-table__header th { background: #edf1f5; color: #334657; }
.detail-note { margin: 10px 0 0; color: #6b7785; font-size: 12px; }
.credit-change { color: #258257; }
.debit-change { color: #c04545; }
.deposit-change { color: #6752aa; }
.detail-timeline { padding: 5px 0 0 5px; }
@media (max-width: 1100px) { .detail-fields { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 700px) { .detail-toolbar { flex-wrap: wrap; } .detail-actions { width: 100%; margin-left: 0; } .detail-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
</style>
